import { Inject, Options, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import { AuthorizedUser } from "@/trust-atcs-app/models/authorized-user";
// import AtcsDashboard from "../atcs-dashboard/index.vue";
// import ExternalExaminerMain from "../external-examiner-main/index.vue";
import { PopoverView } from "@/shared/components/popover/popover";
import { RouteN } from "@/trust-atcs-app/constants/router-name";

@Options({
  components: {
    LoadingSpinner,
    // AtcsDashboard,
    // ExternalExaminerMain
  },
  mixins: [],
})
export default class AppDashboard extends Vue {

  private ai = new AppInsights;
  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private popovers: PopoverView[] = [];

  @Watch('$route')
  private onRouteChange(to: any, from: any) {
    if (to.name == RouteN.ATCS.DashboardMain.n) {
      this.pageRedirection();
    }
  }

  created(): void {
    // this.idleSessionMgr.run(this.idleSessionTimeoutCallback);
    // this.initImpersonatedUser();
    this.pageRedirection();
  }

  private pageRedirection(): void {
    if (this.userAccount.user.isPrincipal || this.userAccount.user.isTrustContact) {
      this.$router.push({ name: RouteN.ATCS.DashboardHome.n });
    } else if (this.userAccount.user.isExternalExaminer) {
      this.$router.push({ name: RouteN.ATCS.EEHome.n });
    } else if (!this.userAccount.user.isExternalExaminer && this.userAccount.user.lawIdUserTypeId == 3 && this.userAccount.user.isInactiveExternalExaminer) {
      this.$router.push({ name: RouteN.ATCS.EEInactive.n });
    } else if (!this.userAccount.user.isExternalExaminer && this.userAccount.user.lawIdUserTypeId == 3) {
      this.$router.push({ name: RouteN.ATCS.EESignUp.n });
    } else {
      this.$router.push({ name: RouteN.NoAccess.n });
    }
  }
  // private view = -1;

  // @Watch('$route')
  // private onRouteChange(to: any, from: any) {
  //   if(to.name == RouteN.ATCS.DashboardMain.n) {
  //     this.view = this.dashboardType();
  //   }
  // }

  // created(): void {
  //   this.view = this.dashboardType();
  // }

  // private dashboardType(): number {
  //   let dashboardType = -1;
  //   if (this.userAccount.user.isPrincipal || this.userAccount.user.isTrustContact) {
  //     dashboardType = 0;
  //     console.log('ATCS Dashboard');
  //   } else if (this.userAccount.user.isExternalExaminer) {
  //     dashboardType = 1;
  //     console.log('EE Dashboard');
  //   } else if (!this.userAccount.user.isExternalExaminer && this.userAccount.user.lawIdUserTypeId == 3) {
  //     dashboardType = 2;
  //     console.log('EE Dashboard');
  //   } else {
  //     dashboardType = -1;
  //   }
  //   return dashboardType;
  // }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

  mounted(): void {
    this.loadPageContents();
  }

  private async loadPageContents(): Promise<void> {
    await this.apiService.PageAtcsApi?.apiV2PageAtcsGetAllPageContentsGet()
      .then((res: any) => {
        for (let p = 0; p < res.data.data.length; p++) {
          this.popovers.push({
            key: res.data.data[p].key.replace('[[', '').replace(']]', '') as string,
            content: res.data.data[p].content as string,
            title: res.data.data[p].title as string,
            pageId: res.data.data[p].pageId as number,
            isShow: res.data.data[p].isShow as boolean,
          })
        }
        store.dispatch('setPopovers', this.popovers);
      }).catch((err) => {
        this.ai.trackException('Error loading page contents: ' + err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Error loading page contents');
      });

  }

}